export const wrapperConstants = {
  router: '/Router/Router',
  applicationName: 'PumpChecker',
} as const;

export const docsWrapperConstants = {
  router: '/Router/Install',
  applicationName: 'PumpChecker',
} as const;

export const createWrapperPayload = (
  callType: 'GET' | 'POST' | 'PUT' | 'DELETE',
  url: string,
  payload?: any,
  isFormData?: boolean,
  areaIds?: string[],
  businessUnitIds?: string[],
  fieldIds?: string[],
  wellIds?: string[] | string,
  wellGroupIds?: string[],
  methodOfProduction?: string,
  allWells?: boolean,
) => {
  const basePayload = {
    apiApplicationName: wrapperConstants.applicationName,
    callType,
    url,
    payload:
      callType === 'POST' || callType === 'PUT'
        ? payload !== undefined
          ? typeof payload === 'string'
            ? payload
            : JSON.stringify(payload)
          : ''
        : '',
    assetId: '',
  };

  const extendedPayload = {
    ...basePayload,
    ...(areaIds ? { areaIds } : {}),
    ...(businessUnitIds ? { businessUnitIds } : {}),
    ...(fieldIds ? { fieldIds } : {}),
    ...(wellIds ? { wellIds: Array.isArray(wellIds) ? wellIds.join(',') : wellIds } : {}),
    ...(wellGroupIds ? { wellGroupIds } : {}),
    ...(allWells ? { allWells } : {}),
    ...(methodOfProduction ? { methodOfProduction } : {}),
  };

  return isFormData ? { ...extendedPayload, IsFormData: 'true' } : extendedPayload;
};

export const createDocsWrapperPayload = (
  callType: 'GET' | 'POST' | 'PUT' | 'DELETE',
  url: string,
  payload?: any,
  assetId?: string,
  IsInstall?: boolean,
) => {
  const basePayload = {
    ApiApplicationName: wrapperConstants.applicationName,
    CallType: callType,
    URL: url,
    Payload: payload !== undefined ? (typeof payload === 'string' ? payload : JSON.stringify(payload)) : '',
    AssetId: assetId || '',
    IsInstall: IsInstall || true,
  };

  return basePayload;
};
